import React, {CSSProperties, HTMLAttributes} from 'react'

export interface RowProps extends HTMLAttributes<HTMLDivElement> {
    style?: CSSProperties
}

/**
 * Lays out its children next to each other (flex row) over the full width.
 * minWidth/minHeight 0 let it shrink inside other flex layouts instead of overflowing them.
 * For form fields use FormRow, which also adds the form spacing.
 */
const Row = ({style, children, ...rest}: RowProps) => {
    return (
        <div {...rest} style={{display: 'flex', width: '100%', minWidth: 0, minHeight: 0, ...style}}>
            {children}
        </div>
    )
}

export default Row
